var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7837 14.6138L10.3804 11.45C10.3256 11.4229 10.2734 11.4102 10.2262 11.4102C10.159 11.4102 10.1021 11.4363 10.0621 11.484C10.023 11.5306 10 11.598 10 11.6823V25.2644C10 25.4956 10.1712 25.7692 10.3804 25.8726L16.2978 28.7963C16.38 28.8369 16.4583 28.8562 16.5291 28.8562C16.7285 28.8562 16.8684 28.7037 16.8684 28.4478V14.7492C16.8684 14.6919 16.8356 14.6394 16.7837 14.6138Z",
    fill: "#A1A1A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2832 25.9521L30.0333 28.7931C30.3471 28.9481 30.6038 28.7913 30.6038 28.4446V15.8027L24.2832 25.9521Z",
    fill: "#A1A1A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4746 15.6309V22.5915L23.736 25.6851L17.4746 15.6309Z",
    fill: "#A1A1A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4532 14.5819L23.9262 11.357C23.8966 11.3423 23.8643 11.3355 23.832 11.3347C23.8299 11.3346 23.8278 11.334 23.8257 11.334C23.7463 11.334 23.6673 11.3734 23.6245 11.442L19.6016 17.902L24.0924 25.1133L30.5158 14.7989C30.5634 14.7224 30.5345 14.622 30.4532 14.5819Z",
    fill: "#A1A1A0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIcon);
export default __webpack_public_path__ + "static/media/MIcon.d52ffeda.svg";
export { ForwardRef as ReactComponent };